module.exports = __webpack_public_path__ + "img/siniestros.67d2ad77.svg";